import styled, { css, DefaultTheme } from 'styled-components/native'
import { TextInput } from 'react-native'

export const StyledInputContainer = styled.View`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  gap: 4px;
`

export const StyledInput = styled(TextInput)<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    ${theme.fonts.styles.bodyLarge}
    background-color: ${disabled ? theme.colors.elementsBorder : theme.colors.elementsBg};
    color: ${disabled ? theme.colors.disabled : theme.colors.text};
    padding-horizontal: ${theme.metrics.baseMargin * 0.75}px;
    height: 46px;
    border-radius: ${theme.metrics.borderRadius.small}px;
    border-width: 1px;
    border-color: ${theme.colors.elementsBorder};
    shadow-color: #000000;
    shadow-offset: 0px 1px;
    shadow-opacity: 0.06;
    shadow-radius: 4px;
    elevation: 2;
    line-height: undefined;
  `}
`

export const StyledInputWrapper = styled.View`
  position: relative;
  flex-direction: row;
  align-items: center;
`

export const StyledIconWrapper = styled.View<{ position: 'left' | 'right' }>`
  position: absolute;
  ${({ position }) => position}: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  z-index: 1;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`

const getBodyLargeText = (theme: DefaultTheme) => {
  const { bodyLarge } = theme.fonts.styles
  return css`
    font-family: ${bodyLarge.fontFamily};
    font-size: ${bodyLarge.fontSize}px;
    font-weight: ${bodyLarge.fontWeight ?? 'normal'};
  `
}

const getBaseInputStyles = (theme: DefaultTheme) => {
  const padding = theme.metrics.baseMargin * 0.75
  const borderRadius = theme.metrics.baseMargin / 2
  return css`
    ${getBodyLargeText(theme)}
    background-color: ${theme.colors.elementsBg};
    color: ${theme.colors.text};
    height: 46px;
    padding-horizontal: ${padding}px;
    border-width: 1px;
    border-color: ${theme.colors.elementsBorder};
    border-radius: ${borderRadius}px;
    ${theme.shadows.soft}
  `
}

const getDisabledInputStyles = (theme: DefaultTheme) => css`
  ${getBaseInputStyles(theme)}
  background-color: ${theme.colors.disabled};
  color: ${theme.colors.textDisabled};
`

export const StyledPlatformInput = styled(TextInput)<{
  disabled?: boolean
  hasIcon?: boolean
  iconPosition?: 'left' | 'right'
  iconSize: number
}>`
  width: 100%;
  ${({ disabled, theme }) => (disabled ? getDisabledInputStyles(theme) : getBaseInputStyles(theme))}
  ${({ hasIcon, iconPosition = 'left', iconSize = 0, theme }) => {
    if (hasIcon) {
      const iconPadding = iconSize + theme.metrics.baseMargin * 1.5
      return iconPosition === 'left'
        ? `padding-left: ${iconPadding}px;`
        : `padding-right: ${iconPadding}px;`
    }
    return ''
  }}
`
